var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Avatar, Heading, Text, Box } from '@chakra-ui/react';
import '../../../../index.css';
var CardFull = function (props) {
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ display: 'flex', alignItems: "center", my: 5 }, { children: [_jsx(Avatar, { name: props.name, src: props.avatar, size: "2xl" }), _jsx(Heading, __assign({ display: 'inline', w: "75%", wordBreak: 'break-word', ml: "5" }, { children: props.name }))] })), _jsxs(Heading, __assign({ fontSize: '1.2rem' }, { children: [" Agency: ", props.agency] })), _jsx(Text, { children: props.bio })] }));
};
export default CardFull;
